import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../html/element'
import { getSampleReport } from './store/thunk'

export const SampleReport = ({ id }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const onClick = () => {
    dispatch(
      getSampleReport({
        FiinGateReportTypeId: id,
        OrganizationId: organizationId,
      }),
    )
  }

  return (
    <Element
      elementName="span"
      style={{ color: '#2C73E8' }}
      className="cursorPointer"
      onClick={onClick}
    >
      <Translate value="common.order.businessCreditReport.SAMPLE_REPORT" />
    </Element>
  )
}
